/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Audit_Window_NoteInputs */



/**
* | output |
* | --- |
* | "Actions recorded for this member over the last 30 days." |
*
* @param {Member_Audit_Window_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_audit_window_note = /** @type {((inputs?: Member_Audit_Window_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Audit_Window_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufgezeichnete Aktionen dieses Mitglieds aus den letzten 30 Tagen.")
	return /** @type {LocalizedString} */ ("Actions recorded for this member over the last 30 days.")
});